<template>
  <div class="page" v-if="can('message.show')">
    <h2 class="accent--text">
      <v-icon color="primary" class="ml-3" large>mdi-email</v-icon>
        إدارة القائمة البريدية
      <back-button />
    </h2>
    <hr class="my-5 header-divider" />

    <!-- TABLE -->
    <v-data-table
      item-key="id"
      class="elevation-1"
      :loading="table.loading"
      :headers="table.headers"
      :items="records"
      loading-text="جاري تحميل البيانات"
      no-data-text="لا يوجد بيانات"
      disable-filtering
      disable-pagination
      disable-sort
      hide-default-footer
    >
      <!-- PATH -->
      <template v-slot:item.page="{ item }">
        <a
          dir="ltr"
          target="_blank"
          class="blue--text"
          :href="websiteUrl + item.page"
        >{{ item.page }}</a>
      </template>
      <!-- CONTROLS -->
      <template v-slot:item.controls="{ item }">
        <v-btn
          v-if="can('message.delete')"
          small
          icon
          color="error"
          class="mx-2"
          @click="remove(item)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <!-- PAGINATION -->
    <div class="text-center mt-7">
      <v-pagination
        total-visible="7"
        circle
        :value="parseInt(filters.page)"
        :length="totalPages"
        @input="$router.replace({ query: { ...$route.query, page: $event } })"
      ></v-pagination>
    </div>
  </div>
</template>


<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'contact-us',

  data: function () {
    return {
      table: {
        headers: [
          {
            value: 'id',
            text: 'مسلسل'
          },
          {
            value: 'email',
            text: 'البريد الإلكتروني'
          },
          {
            value: 'page',
            text: 'المسار'
          },
          {
            value: 'created_at',
            text: 'تاريخ الإضافة'
          },
          {
            value: 'controls',
            text: 'اعدادات'
          }
        ],
        loading: false
      },

      websiteUrl: process.env.VUE_APP_WEBSITE_BASE_URL
    }
  },


  computed: {
    ...mapState('emails', ['records', 'filters', 'totalPages']
    )
  },


  watch: {
    '$route': {
      async handler(route) {
        if (!route.query.page) {
          await this.$router.replace({ query: { ...route.query, page: 1 } });
          return;
        }

        this.SET_FILTERS(route.query);
        this.fetchRecords();
      },
      deep: true,
      immediate: true,
    }
  },


  methods: {
    ...mapMutations(
      'emails', ['SET_FILTERS']
    ),

    fetchRecords() {
      this.table.loading = true;

      this.$store.dispatch('emails/fetchRecords')
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر جلب البيانات, يرجي التأكد من حالة الشبكة',
            color: 'accent'
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    },

    async remove(selectedRecord) {
      const confirmMessageParams = [
        `حذف البريد الإلكتروني رقم ${selectedRecord.id}!`,
        `هل أنت متأكد من حذف البريد الإلكتروني؟`,
        { color: 'error' }
      ];
      if (!await this.$root.$confirm(...confirmMessageParams)) return;

      this.table.loading = true;

      this.$store.dispatch('emails/delete', { recordId: selectedRecord.id })
        .then(() => {
          this.$bus.$emit('showSnackbar', {
            text: 'تم حذف البريد الإلكتروني بنجاح',
            color: 'success'
          });
        })
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر حذف البريد الإلكتروني',
            color: 'accent'
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    }
  }
}
</script>
